// extracted by mini-css-extract-plugin
export default {"page":"ChangeIpPage_page__o98MZ","container":"ChangeIpPage_container__ihLC7","label":"ChangeIpPage_label__CJJKk","value":"ChangeIpPage_value__Z+4AK"};